<!-- {{control.errors | json}} -->
<div [ngClass]="{'has-error': hasError(), 'has-placeholder-error': hasPlaceHoderError()}">
  <ng-content></ng-content>
  <ng-container *ngFor="let errorKey of errorKeys">
    <span class="help-block" *ngIf="control.hasError(errorKey) && control.touched && showError">
      {{formateError(errorObject[errorKey],control.errors[errorKey])}}
    </span>
  </ng-container>
  <span class="help-block" *ngIf="apiErrorMessage">
    {{apiErrorMessage}}
  </span>
</div>
